import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, List, ListItem, ModalHeader, Typography } from 'common/components';
import { css } from 'linaria';
import { KITCHEN_ELEMENT_BLOCK } from '../../../../../kitchen-constants';
import {
  kitchenHeaderCardModalList,
  kitchenHeaderCardModalText,
  kitchenHeaderCardModalTitle,
} from '../../kitchen-header-card-styles';

const guaranteeModalFooter = css`
  && {
    padding-top: 24px;
  }
`;

export const Guarantee = ({ onCloseModal }: { onCloseModal: () => void }) => (
  <>
    <ModalHeader className={kitchenHeaderCardModalTitle} title="Гарантия 25&nbsp;лет на&nbsp;все изделия*" />
    <ModalContent>
      <Typography className={kitchenHeaderCardModalText} variant="m" size="body_long">
        Мы&nbsp;даём гарантию 25&nbsp;лет на&nbsp;все основные комплектующие кухни:
      </Typography>
      <List listStyle="disc" className={kitchenHeaderCardModalList}>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            каркасы;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            фасады;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            металлические выдвижные ящики;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            петли для фасадов (с&nbsp;доводчиком и&nbsp;без). все комплектующие кухонь Delinia&nbsp;ID
          </Typography>
        </ListItem>
      </List>
      <Typography className={kitchenHeaderCardModalText} variant="m" size="body_long">
        Вернуть товар надлежащего качества можно в&nbsp;течение 100 или 365 дней с&nbsp;момента покупки:
      </Typography>
      <List listStyle="disc" className={kitchenHeaderCardModalList}>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            в&nbsp;течение 100 дней по&nbsp;чеку или номеру заказа&nbsp;&mdash; для любого покупателя;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            в&nbsp;течение 365 дней без чека&nbsp;&mdash; для покупателей с&nbsp;Ключ-картой для дома.
          </Typography>
        </ListItem>
      </List>
    </ModalContent>
    <ModalFooter className={guaranteeModalFooter}>
      <ButtonWithGAClickButton
        onClick={onCloseModal}
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        elementName="Смотреть полные условия"
        elementText="Гарантия 25 лет на все изделия"
        href="https://storage.yandexcloud.net/lemanapro-ru-landings-docs/kitchen/Delinia_guarantee.pdf"
        wide
        target="_blank">
        Смотреть полные условия
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
